export const locales = {
    fr_be: {
        label: "Français (Belgique)",
        dayjs: () => import('dayjs/locale/fr.js'),
        flatpickr: () => import("flatpickr/dist/l10n/fr").then((module) => module.French),
        flag: 'belgium'
    },
    nl_be: {
        label: "Nederlands (België)",
        dayjs: () => import('dayjs/locale/nl-be.js'),
        flatpickr: () => import("flatpickr/dist/l10n/nl").then((module) => module.Dutch),
        flag: 'belgium'
    },
    en: {
        label: "English",
        dayjs: () => import('dayjs/locale/en.js'),
        flatpickr: null,
        flag: 'united-kingdom'
    }
}